import { render, staticRenderFns } from "./add.vue?vue&type=template&id=a8f00368&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=a8f00368&prod&scoped=true&lang=scss"
import style1 from "./add.vue?vue&type=style&index=1&id=a8f00368&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f00368",
  null
  
)

export default component.exports